import Container from '@brands/Components/Container/Container';
import { useWindowSize } from '@brands/hooks';
import useLoadDependents from '@brands/hooks/useLoadDependents';
import { useUnsavedChangesWarning } from '@brands/hooks/useUnsavedChangesWarning';
import { parsePhoneNumber } from 'libphonenumber-js';
import React, { useEffect, useRef, useState } from 'react';

import ProfileCommonHeader from '../MyProfile/Patient/Sections/ProfileCommonHeader/ProfileCommonHeader';
import CareHistory from './Sections/CareHistory';
import UpcomingAppointments from './Sections/UpcomingAppointments';
import styles from './styles.module.scss';

export const isValidPhoneNumberFormat = (phoneNumber: string): boolean => {
  const phoneNumberPattern = /^\+?1?[-.\s]?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;

  return phoneNumberPattern.test(phoneNumber);
};

export const displayPhoneNumber = (pharmacyPhoneNumber: string): string => {
  const phoneNumber = parsePhoneNumber(pharmacyPhoneNumber, 'US');
  if (phoneNumber) {
    return phoneNumber.formatNational();
  }
  return '';
};

const MyCare = (): JSX.Element => {
  const screenSize = useWindowSize();
  const [currentTab, setCurrentTab] = useState('upcoming_appointments');
  const containerRef = useRef<HTMLDivElement>(null);

  const formRef = useRef<HTMLFormElement>(null);
  useLoadDependents();

  const { handleBlockedNavigation } = useUnsavedChangesWarning(false, formRef);

  const myCareTabs = [
    { label: 'Upcoming appointments', value: 'upcoming_appointments' },
    { label: 'Care history', value: 'care_history' },
  ];

  const handleTabChange = (nextTab: string): void => {
    if (nextTab === currentTab) return;
    handleBlockedNavigation(() => {
      setCurrentTab(nextTab);
      window.history.replaceState(null, '', `#${nextTab}`);
    });
  };

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setCurrentTab(hash);
    }
  }, [window.location.hash]);

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
    >
      <div className={styles.MyCareContainer} ref={containerRef}>
        <ProfileCommonHeader
          currentTab={currentTab}
          handleTabChange={handleTabChange}
          tabs={myCareTabs}
          // An unselected tab was on MUI's default grey rather than the product
          // navy the design system uses. Size and weight live on the shared
          // header's stylesheet and now follow the prototypes; only the colour
          // is set from here.
          sx={{ tab: { color: 'var(--color-text-primary)' } }}
        />

        {currentTab === 'upcoming_appointments' && <UpcomingAppointments />}
        {currentTab === 'care_history' && <CareHistory />}
      </div>
    </Container>
  );
};

MyCare.defaultProps = {
  reviewProfile: false,
};

export default MyCare;
